import { createTheme as createMuiTheme } from '@mui/material/styles';
import { find, isEmpty, merge } from 'lodash';

import { ThemeConfig } from 'context/theme.context';

import breakpoints from './breakpoints';
import components from './components';
import shadows from './shadows';
import typography from './typography';
import { singleThemeSchema } from './validator';
import { VariantType, defaultVariant, variants } from './variants';

const createTheme = (name: string, themeConfigObject: ThemeConfig) => {
  let themeConfig: VariantType = themeConfigObject[name];

  if (!themeConfig) {
    themeConfig = defaultVariant;

    if (!isEmpty(themeConfigObject)) {
      // eslint-disable-next-line no-console
      console.warn(new Error(`The theme ${name} is not valid`));
    }
  } else {
    try {
      singleThemeSchema.validateSync(themeConfig);
      const baseSchemaVariant =
        find(variants, (variant) => variant.name === themeConfig.name) ||
        defaultVariant;
      themeConfig = merge({}, baseSchemaVariant, themeConfig);
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.warn(
        new Error(`The theme configuration is not valid: ${error.message}`),
      );
      themeConfig = defaultVariant;
    }
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints,
      // @ts-ignore
      components,
      typography,
      shadows,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
  );
};

export default createTheme;
